import { SimpleGrid, Tabs } from "@mantine/core";
import DemoCard from "../DemoCard/DemoCard";
import demoLinks from "../demoLinks.json";
import { demoOptions } from "../utils";
import { imgCDN } from "@/constants.ts";
import {
  EVENT_IDS,
  TAX_TUESDAY_IMG_URL,
  WILD_WEDNESDAY_IMG_URL,
} from "../DemoHeader/DemoSubHeader/utils";

interface DemoTabsProps {
  recordings?: Record<string, { urls: string[] }>;
}

const DemoTabs = ({ recordings = {} }: DemoTabsProps) => {
  // Transform recordings object into a flat array with categorization and appropriate images
  const transformedRecordings = Object.entries(recordings).flatMap(
    ([key, value]) =>
      value.urls.map((url, index) => {
        const isTaxTuesday = key === EVENT_IDS.taxTuesday;
        const image = isTaxTuesday
          ? TAX_TUESDAY_IMG_URL
          : WILD_WEDNESDAY_IMG_URL;

        return {
          id: `${key}-${index}`,
          link: url,
          title: `Recording ${index + 1}`,
          image,
          category: key,
        };
      })
  );

  // Filter recordings by category
  const taxTuesdayRecordings = transformedRecordings.filter(
    (recording) => recording.category === EVENT_IDS.taxTuesday
  );
  const wildWednesdayRecordings = transformedRecordings.filter(
    (recording) => recording.category === EVENT_IDS.wildWednesday
  );

  return (
    <Tabs radius="md" defaultValue={demoOptions[0].value}>
      <Tabs.List>
        {demoOptions.map((option) => (
          <Tabs.Tab key={option.value} value={option.value}>
            {option.label}
          </Tabs.Tab>
        ))}
        <Tabs.Tab value="tax-tuesday">Tax Tuesday</Tabs.Tab>
        <Tabs.Tab value="wild-wednesday">Wild Wednesday</Tabs.Tab>
      </Tabs.List>

      {demoOptions.map((option) => {
        // Filter demoLinks based on the selected tab value
        const filteredLinks =
          option.value === "all-resources"
            ? demoLinks
            : demoLinks.filter((demo) => demo.type === option.value);

        return (
          <Tabs.Panel key={option.value} value={option.value}>
            <SimpleGrid cols={3} spacing="lg" mt="xl">
              {filteredLinks.map((demo) => (
                <DemoCard
                  key={demo.link}
                  demoLink={demo.link}
                  demoTitle={demo.title}
                  demoTime={demo.time}
                  demoImage={`${imgCDN}${demo.image}`}
                />
              ))}
            </SimpleGrid>
          </Tabs.Panel>
        );
      })}

      <Tabs.Panel key="tax-tuesday" value="tax-tuesday">
        <SimpleGrid cols={3} spacing="lg" mt="xl">
          {taxTuesdayRecordings.map((recording) => (
            <DemoCard
              key={recording.id}
              demoLink={recording.link}
              demoTitle={recording.title}
              demoImage={recording.image}
            />
          ))}
        </SimpleGrid>
      </Tabs.Panel>

      <Tabs.Panel key="wild-wednesday" value="wild-wednesday">
        <SimpleGrid cols={3} spacing="lg" mt="xl">
          {wildWednesdayRecordings.map((recording) => (
            <DemoCard
              key={recording.id}
              demoLink={recording.link}
              demoTitle={recording.title}
              demoImage={recording.image}
            />
          ))}
        </SimpleGrid>
      </Tabs.Panel>
    </Tabs>
  );
};

export default DemoTabs;
